export default "/react/wildberries-206d561a.svg";